import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import BookingSection from "../components/BookingSection";
import TransformativeSection from "../components/TransformativeSection";
import FeaturedHotels from "../components/FeaturedHotels";
import JourneySection from "../components/JourneySection";
import YachtCollectionSection from "../components/YachtCollectionSection";
import ExperienceSection from "../components/ExperienceSection";
import RecirculationCarousel from "../components/RecirculationCarousel";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <BookingSection />
      <TransformativeSection />
      <FeaturedHotels />
      <JourneySection />
      <YachtCollectionSection />
      <ExperienceSection />
      <RecirculationCarousel />
      <Footer />
    </div>
  );
};

export default Home;